// Single source of truth for API configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "https://api-dev.sospita.io",
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
};

// Export just the base URL for backwards compatibility
export const BASE_URL = API_CONFIG.BASE_URL;
